/** Buyer-facing labels for courier shipment pickup/delivery progress. */

const PICKUP_STATUS_LABELS = {
  pending: 'Awaiting pickup',
  in_progress: 'Partially picked up',
  picked_up: 'Picked up from sellers',
  problem: 'Pickup issue',
};

const DELIVERY_STATUS_LABELS = {
  pending: 'Preparing delivery',
  in_transit: 'In transit',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  returned_to_seller: 'Returned to seller',
  returned: 'Returned to seller',
  problem: 'Delivery issue',
};

export const formatPickupStatusLabel = (status) => {
  if (!status) return '—';
  return PICKUP_STATUS_LABELS[status] || String(status).replace(/_/g, ' ');
};

export const formatDeliveryStatusLabel = (status) => {
  if (!status) return '—';
  const key = String(status).toLowerCase();
  return DELIVERY_STATUS_LABELS[key] || key.replace(/_/g, ' ');
};

export const isShipmentDelivered = (deliveryStatus) => (
  String(deliveryStatus || '').toLowerCase() === 'delivered'
);

export const isShipmentInProgress = (deliveryStatus) => {
  const s = String(deliveryStatus || '').toLowerCase();
  return ['in_transit', 'out_for_delivery'].includes(s);
};

export const getDeliveryStatusBadgeColor = (status) => {
  const s = String(status || '').toLowerCase();
  if (s === 'delivered') return '#10b981';
  if (s === 'returned_to_seller' || s === 'returned') return '#8b5cf6';
  if (s === 'problem') return '#ef4444';
  if (s === 'in_transit' || s === 'out_for_delivery') return '#3b82f6';
  return '#f59e0b';
};
